export const ARTWORK_ROUTING_DEBUG_KEY = "artworkRouting";
export const ARTWORK_ROUTING_DEBUG_STORAGE_KEY = "SuarteDebug.artworkRouting";

function isLocalArtworkDebugEnvironment() {
  if (process.env.NODE_ENV === "development") {
    return true;
  }

  if (typeof window === "undefined") {
    return false;
  }

  const host = window.location?.hostname ?? "";
  return host === "localhost" || host === "127.0.0.1";
}

function getArtworkRoutingDebugConfigFromStorage() {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }

  const raw = window.localStorage.getItem(ARTWORK_ROUTING_DEBUG_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  if (raw === "true") {
    return { enabled: true };
  }

  if (raw === "false") {
    return { enabled: false };
  }

  try {
    const parsed = JSON.parse(raw);
    if (parsed === true) {
      return { enabled: true };
    }
    if (parsed === false) {
      return { enabled: false };
    }
    if (parsed && typeof parsed === "object") {
      return parsed;
    }
  } catch (_) {
    return null;
  }

  return null;
}

function getArtworkRoutingDebugConfig() {
  if (typeof window !== "undefined" && window.SuarteDebug) {
    const config = window.SuarteDebug[ARTWORK_ROUTING_DEBUG_KEY];
    if (config === true) {
      return { enabled: true };
    }
    if (config && typeof config === "object") {
      return config;
    }
  }
  return getArtworkRoutingDebugConfigFromStorage();
}

export function isArtworkRoutingDebugEnabled() {
  if (!isLocalArtworkDebugEnvironment()) {
    return false;
  }

  const config = getArtworkRoutingDebugConfig();
  if (!config) {
    return false;
  }
  if (typeof config.enabled === "boolean") {
    return config.enabled;
  }
  return true;
}
